import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';

import dateUtils from '../../../util/dates';
import chartUtils from '../../../util/chartUtils';
const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'spline',
  },
  title: {
    text: '',
  },
  xAxis: {
    type: 'datetime',
    labels: {
      style: {
        fontSize: '12px',
      },
    },
    tickmarkPlacement: 'on',
    title: {
      enable: false,
    },
  },
  yAxis: {
    opposite: false,
    min: 0,
    max: 100,
    labels: {
      format: '{value}%',
      style: {
        fontSize: '12px',
      },
    },
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,
    title: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    spline: {
      color: chartUtils.CARD_LINE_COLORS[0],
      lineWidth: 1.5,
      marker: {
        symbol: 'circle',
        radius: 3,
      },
    },
  },
  series: [
    {
      name: 'Flow Efficiency',
      data: [],
    },
  ],
};

class FlowEfficiencyChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    this.updateTimeLabelsFormat(this.props.dateFormat);

    if (this.props.data && this.props.data.length) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.updateChart();
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateTimeLabelsFormat(this.props.dateFormat);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart() {
    this.chart.series[0].setData((this.props.data || []).map(month => (month.cardCount ? month : { ...month, y: null })), true);
  }

  updateTimeLabelsFormat(dateFormat) {
    let config = { xAxis: {} };
    config.xAxis.dateTimeLabelFormats = dateUtils.createHighchartFormats(dateFormat);

    this.chart.update(config);
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dateFormat: state.filters.dateFormat,
  };
};

export default connect(mapStateToProps)(FlowEfficiencyChart);
